import { Translation, TranslationProps } from "./Translation";

export interface TranslatableEntityProps {
  translations: TranslationProps[];
}

export abstract class TranslatableEntity {
  readonly translations: Translation[];

  protected constructor(props: TranslatableEntityProps) {
    this.translations = props.translations.map(Translation.of);
  }

  getTranslation(locale: string): Translation {
    const shortLocale = locale.includes("-") ? locale.split("-")[0] : locale;
    return this.translations.find(it => it.locale === shortLocale) ?? this.translations[0];
  }
}
